// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/index.scss';
import 'semantic-ui-css/semantic.min.css';
import 'index.css';
import 'element-theme-default';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
